export const FORECAST_FOLDER_EXPANSION_LIMIT = 1000;

export enum ArpsDesignerKind {
  Forecasting = "Forecasting",
  TypeWell = "TypeWell"
}

export enum TypeWellInputTableMode {
  Product = "Product",
  Segment = "Segment"
}

export enum ExpandedKeys {
  ExpandedTypeWellKeys = "expandedTypeWellKeys",
  ExpandedForecastKeys = "expandedForecastKeys"
}

export enum FilteredFolders {
  FilteredTypeWellFolders = "filteredTypeWellFolders",
  FilteredForecastFolders = "filteredForecastFolders"
}

export enum ForecastFolders {
  TypeWellFolders = "typeWellFolders",
  ForecastFolders = "forecastFolders"
}

export enum CheckedForecasts {
  CheckedTypeWells = "checkedTypeWells",
  CheckedForecasts = "checkedForecasts"
}

export enum CheckedKeys {
  CheckedTypeWellKeys = "checkedTypeWellKeys",
  CheckedForecastKeys = "checkedForecastKeys"
}

export enum ProductNames {
  Oil = "OIL",
  OilPlusCond = "OIL + COND",
  Gas = "GAS",
  SalesGas = "SALES GAS",
  Water = "WATER",
  Steam = "STEAM",
  Condensate = "CONDENSATE",
  CondAbbreviated = "COND",
  CondAbbreviatedWithDot = "COND.",
  C2 = "C2",
  C3 = "C3",
  C4 = "C4",
  C5 = "C5",
  C5PlusGR = "C5+GR",
  HV = "HV",
  Shrinkage = "SHRINKAGE",
  GOR = "GOR",
  CGR = "CGR",
  OGR = "OGR",
  WOR = "WOR",
  WGR = "WGR",
  OnePlusWOR = "1+WOR",
  OilPlusWater = "O+W",
  SOR = "SOR"
}

export enum ArpFields {
  EUR = "EUR", // Unrestricted EUR / Technical EUR
  TotalEUR = "TotalEUR",
  CTD = "CTD",
  RestrictedEUR = "CutoffEUR", // EUR value when restricted/cut off at the primary product's end date
  QfAtCutoff = "CutoffQf", // Flow rate (Qf) at the primary product's end date
  Q0 = "Q0",
  Qi = "Qi",
  Qf = "Qf",
  Di = "Di",
  Df = "Df",
  B = "B",
  TRamp = "tRamp",
  TFlat = "tFlat",
  TTrans = "tTrans",
  TCons = "tCons",
  Duration = "Duration",
  StartDate = "Start Date",
  EndDate = "End Date",
  MaxRate = "maxRate"
}

export enum DurationUnit {
  Months = "months",
  Year = "yr",
  AverageMonth = "avg month"
}

export enum WasmProduct {
  Oil = "Oil",
  Gas = "Gas",
  Water = "Water",
  OilCondC5 = "OilCondC5"
}

export enum ForecastMonthField {
  OilBbl = "oil_bbl",
  GasMcf = "gas_mcf",
  WaterBbl = "water_bbl",
  CondBbl = "cond_bbl"
}
